import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

const FlightSelectionDialog = ({ open, onOpenChange, options, onSelect, flightNumber, date }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle data-testid="flight-selection-dialog-title">Multiple Flights Found</DialogTitle>
          <DialogDescription>
            Flight {flightNumber} operates multiple times{date ? ` on ${date}` : ' on this date'}.
            Please select which flight you want:
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-4">
          {options?.map((option) => (
            <button
              key={option.index}
              onClick={() => onSelect(option.index)}
              className="w-full p-4 text-left border-2 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors"
              data-testid={`flight-option-${option.index}`}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="font-semibold text-lg text-blue-900">
                    {option.route_display}
                  </div>
                  <div className="text-sm text-gray-600 mt-1">
                    {option.departure_airport} → {option.arrival_airport}
                  </div>
                  {/* Handle both formats: AddSegment uses scheduled_time, ItineraryView uses departure_time/arrival_time */}
                  {option.scheduled_time && (
                    <div className="text-sm text-gray-500 mt-1">
                      Departure: {option.scheduled_time}
                    </div>
                  )}
                  {(option.departure_time || option.arrival_time) && !option.scheduled_time && (
                    <div className="text-sm text-gray-700 mt-2 font-medium">
                      {option.departure_time && <span>Departs: {option.departure_time}</span>}
                      {option.arrival_time && <span className="ml-4">Arrives: {option.arrival_time}</span>}
                    </div>
                  )}
                  {!option.departure_time && !option.arrival_time && !option.scheduled_time && (
                    <div className="text-xs text-amber-600 mt-1">
                      Times not available - select based on your known flight details
                    </div>
                  )}
                </div>
                <ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0" />
              </div>
            </button>
          ))}
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            data-testid="flight-selection-cancel-btn"
          >
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default FlightSelectionDialog;
